export class PharmacyDetails {
  rxEligible: string;
  rxPbmName: string;
  rxPbmUrl: string;
  enabled: boolean;

  constructor(obj: PharmacyDetails) {
    this.rxEligible = obj['RxEligibility'] || '';
    this.rxPbmName = obj['RxPbmName'] || '';
    this.rxPbmUrl = obj['RxPbmUrl'] || '';
    this.enabled = this.rxEligible === 'Y';
  }
}
